<ngx-spinner type="ball-spin-clockwise"></ngx-spinner>
<router-outlet></router-outlet>